<template>
    <i  class="percents"
        v-if="compare !== '0.00'"
        :class="{
            positive: total >= 0,
            negative: total === -1
        }"
    >
        <icon v-if="total !== 0" :name="name" /> <template v-if="total !== 0">{{ percent | percentage }}</template>
        <template v-else>0%</template>
    </i>
</template>

<script>
export default
{
    name: 'Percents',

    props:
    {
        base:
        {
            type: [String]
        },

        compare:
        {
            type: [String]
        }
    },

    computed:
    {
        name()
        {
            if (this.total === 1) return 'arrow-upward';
            if (this.total === -1) return 'arrow-downward';
        },

        total()
        {
            if (parseFloat(this.base) > parseFloat(this.compare)) return 1;
            if (parseFloat(this.base) === parseFloat(this.compare)) return 0;
            if (parseFloat(this.base) < parseFloat(this.compare)) return -1;
        },

        percent()
        {
            if (this.compare === '0.00') return 0.00;
            return ((parseFloat(this.base) - parseFloat(this.compare)) / Math.abs(parseFloat(this.compare))) * 100
        }
    }
}
</script>



// WEBPACK FOOTER //
// Percents.vue?4d92f31c